export const experience = [ 
    {},
    {label: 'Student', value: 'Student'}, 
    {label: 'Early Career', value: 'Early Career'}, 
    {label: 'Mid-career/ experienced', value: 'Mid-career/ experienced'},
    {label: 'People Manager', value: 'People Manager'},
    {label: 'Director +', value: 'Director +'},
    {label: 'VP +', value: 'VP +'},
    {label: 'C Level ', value: 'C Level '},
    {label: ' Founder/ Entrepreneur ', value: ' Founder/ Entrepreneur '}
]